// Feature toggle configuration
// This file controls which features are enabled/disabled across the entire application

const features = {
  // Navigation items
  navigation: {
    features: true,     // Features section on landing page
    coverage: true,     // Coverage page (standalone)
    security: true,     // Security page (new)
    pricing: false,     // Pricing section - DISABLED (not ready yet)
    news: false,        // News page - DISABLED (content not ready)
    try: true,         // Try/Contact section
  },

  // Sections on landing page
  sections: {
    hero: true,        // Hero section
    video: true,       // Video demonstration section
    features: true,    // Features showcase
    pricing: false,    // Pricing plans - DISABLED
    testimonials: false, // Customer testimonials - DISABLED
    tryContact: true,  // Contact form section
  },

  // Other features
  googleAnalytics: true,  // GA4 tracking
  utmTracking: true,      // UTM parameter tracking
  multiLanguage: true,    // Language switcher (EN/HR)
  cookieBanner: false,    // Cookie consent banner - DISABLED
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (category, feature) => {
  if (!features[category]) return false;
  return features[category][feature] === true;
};

// Get enabled navigation items
export const getEnabledNavigationItems = () => {
  return Object.entries(features.navigation)
    .filter(([_, enabled]) => enabled)
    .map(([item, _]) => item);
};

// Get enabled sections
export const getEnabledSections = () => {
  return Object.entries(features.sections)
    .filter(([_, enabled]) => enabled)
    .map(([section, _]) => section);
};

export default features;
